import React, { useEffect, useState } from 'react';
import SettingsCompliance from '~/src/components/Settings/SettingsCompliance';
import { useCurrentOrgFprint } from '~/src/entities/user/hooks/useCurrentOrg';
import { useCbsIntegrationEnabled } from '~/src/entities/user/hooks/useFeatureAccess';
import env from '~/src/utils/env';

const SettingsComplianceContainer = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [legalAgreementUrl, setLegalAgreementUrl] = useState<string | null>(
    null,
  );
  const [legacyTosUrl, setLegacyTosUrl] = useState<string | null>(null);
  const orgFprint = useCurrentOrgFprint();
  const isCbsIntegrationEnabled = useCbsIntegrationEnabled();

  useEffect(() => {
    if (isCbsIntegrationEnabled) {
      fetchLegalAgreementUrl();
    } else {
      setLegacyTosUrl(env.termsOfServiceUrl);
      setIsLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCbsIntegrationEnabled]);

  const fetchLegalAgreementUrl = async () => {
    setIsLoading(true);
    setErrorMessage(null);
    setLegalAgreementUrl(null);
    setLegacyTosUrl(null);
    try {
      const response = await fetch(
        `/cbs_subscriptions/org/${orgFprint}/legal-agreements/`,
      );
      const data = await response.json();
      if (!response.ok) {
        setErrorMessage(
          data.error ||
            'An error has occurred while loading your Legal Agreements.',
        );
        setIsLoading(false);
        return;
      }
      setLegalAgreementUrl(data.legal_agreements_url);
    } catch (err) {
      setErrorMessage(
        'An error has occurred while loading your Legal Agreements.',
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <SettingsCompliance
      isLoading={isLoading}
      errorMessage={errorMessage}
      legalAgreementUrl={legalAgreementUrl}
      legacyTosUrl={legacyTosUrl}
    />
  );
};

export default SettingsComplianceContainer;
